import React, { useState, useEffect, useContext } from "react";
import { ContextAPI } from "../../../../ContextAPI";
import {
  Table,
  Input,
  Dropdown,
  Select,
  Typography,
  Button,
  Icon,
  DatePicker,
  Modal,
  Menu,
  Pagination,
  Tag,
} from "antd";
import { platformApi } from "../../../../api";
import AddTransferSparesModal from "./AddTransferSparesModal";
import moment from "moment";

const { Title } = Typography;
const { Option } = Select;
const { Search } = Input;
const { Item } = Menu;

const PAGE_SIZE_OPTIONS = [5, 10, 15, 20];

const TransferSpares = () => {
  const [addFlag, setAddFlag] = useState(false);
  const [createAccess, setCreateAccess] = useState(false);
  const { loginCredintials } = useContext(ContextAPI);
  const [spareTransfers, setSpareTransfers] = useState([]);
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [branchOptions, setBranchOptions] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [fromBranch, setFromBranch] = useState(undefined);
  const [searchString, setSearchString] = useState("");
  const [filters, setFilters] = useState({});
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [pendingTransfers, setPendingTransfers] = useState([]);
  const [autoTransferData, setAutoTransferData] = useState(null);

  const getMenu = () => {
    return PAGE_SIZE_OPTIONS.map((menu) => (
      <Item onClick={() => handlePageSizeChange(menu)} key={menu}>
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  useEffect(() => {
    getSpareTransfers();
    getPendingTransfers();
    // eslint-disable-next-line
  }, [page, limit, filters]);

  useEffect(() => {
    getBranch();
    const handlePendingUpdate = () => getPendingTransfers();
    window.addEventListener("pendingTransfersUpdated", handlePendingUpdate);
    return () => {
      window.removeEventListener("pendingTransfersUpdated", handlePendingUpdate);
    };
  }, []);

  const getPendingTransfers = () => {
    platformApi
      .get("/api/sparesInventory/pendingTransfers")
      .then((res) => {
        if (res?.data?.response?.code === 200) {
          setPendingTransfers(res.data.response.data.recommendations || []);
        }
      })
      .catch((err) => console.error("Error fetching pending transfers:", err));
  };

  useEffect(() => {
    if (loginCredintials && loginCredintials.roleAccess) {
      loginCredintials.roleAccess.forEach((each) => {
        if (each.subModule === "transfer_spares") {
          if (each.access.create) {
            setCreateAccess(true);
          }
        }
      });
    }
  }, [loginCredintials]);

  const getSpareTransfers = () => {
    setLoading(true);
    platformApi
      .post(`/api/inventoryTransfers/spare-transfers`, {
        size: limit,
        page,
        ...filters,
      })
      .then((res) => {
        setSpareTransfers(res.data.data || []);
        setCount(res.data.count || 0);
      })
      .finally(() => setLoading(false));
  };

  const getBranch = () => {
    platformApi.get(`/api/user/branch`).then((res) => {
      setBranchOptions(res.data.data);
    });
  };

  const handleSearch = (value) => {
    setFilters((prev) => ({ ...prev, searchString: value || undefined }));
    setPage(1);
  };

  const handlePageChange = (pageNum) => {
    setPage(pageNum);
  };

  const handlePageSizeChange = (size) => {
    setLimit(size);
    setPage(1);
  };

  // Advanced filter search handler
  const handleAdvancedSearch = () => {
    const newFilters = {
      ...filters,
      fromBranch,
      startDate: fromDate ? fromDate.format("YYYY-MM-DD") : undefined,
      endDate: toDate ? toDate.format("YYYY-MM-DD") : undefined,
    };
    setFilters(newFilters);
    setPage(1);
  };

  // Advanced filter clear handler
  const handleAdvancedClear = () => {
    setFromDate(null);
    setToDate(null);
    setFromBranch(undefined);
    setFilters({});
    setPage(1);
  };

  const columns = [
    {
      title: "S.no",
      dataIndex: "sno",
      key: "sno",
      render: (text, record, index) => (page - 1) * limit + index + 1,
      width: 70,
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => moment(date).format("DD-MM-YYYY"),
      width: 110,
    },
    {
      title: "Transfer No",
      dataIndex: "transferNo",
      key: "transferNo",
      render: (text) => <strong style={{ color: "#006666" }}>{text || "-"}</strong>,
      width: 140,
    },
    {
      title: "From Branch",
      dataIndex: "fromBranchName",
      key: "fromBranchName",
      width: 150,
    },
    {
      title: "To Branch",
      dataIndex: "toBranchName",
      key: "toBranchName",
      width: 150,
    },
    {
      title: "Part Number",
      dataIndex: "partNumber",
      key: "partNumber",
      width: 180,
    },
    {
      title: "Part Name",
      dataIndex: "partName",
      key: "partName",
      width: 160,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: 90,
    },
  ];

  return (
    <div>
      {pendingTransfers.length > 0 && (
        <div
          style={{
            background: "#fff2f0",
            border: "1px solid #ffccc7",
            borderRadius: 8,
            padding: 16,
            marginBottom: 20,
            boxShadow: "0 2px 8px rgba(255, 77, 79, 0.12)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 18, color: "#ff4d4f" }}>⚡</span>
              <h4 style={{ margin: 0, color: "#cf1322", fontWeight: 700, fontSize: 16 }}>
                Pending Cross-Branch Transfers ({pendingTransfers.length} Action Needed)
              </h4>
            </div>
            <span style={{ color: "#8c8c8c", fontSize: 13 }}>
              Inwarded physical stock available in source branch matches pending demand in target branch.
            </span>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {pendingTransfers.map((rec, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "#ffffff",
                  border: "1px solid #ffd591",
                  borderRadius: 6,
                  padding: "12px 16px",
                  flexWrap: "wrap",
                  gap: 12,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 24, flexWrap: "wrap" }}>
                  <div>
                    <span style={{ fontSize: 12, color: "#8c8c8c", display: "block" }}>From (Source Branch)</span>
                    <span style={{ color: "#389e0d", fontWeight: 600, fontSize: 14 }}>{rec.fromBranchName}</span>
                  </div>
                  <div style={{ fontSize: 16, color: "#1890ff", fontWeight: "bold" }}>➔</div>
                  <div>
                    <span style={{ fontSize: 12, color: "#8c8c8c", display: "block" }}>To (Target Branch)</span>
                    <span style={{ color: "#096dd9", fontWeight: 600, fontSize: 14 }}>{rec.toBranchName}</span>
                  </div>
                  <div>
                    <span style={{ fontSize: 12, color: "#8c8c8c", display: "block" }}>Parts & Quantities</span>
                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 2 }}>
                      {Array.isArray(rec.items) ? (
                        rec.items.map((item, iKey) => (
                          <Tag key={iKey} color="blue" style={{ fontSize: 12, margin: 0 }}>
                            {item.partNumber || item.partName}: <strong>{item.suggestedTransferQty} Qty</strong>
                          </Tag>
                        ))
                      ) : (
                        <Tag color="blue">{rec.partNumber}: <strong>{rec.suggestedTransferQty} Qty</strong></Tag>
                      )}
                    </div>
                  </div>
                  <div>
                    <span style={{ fontSize: 12, color: "#8c8c8c", display: "block" }}>Total Quantity</span>
                    <Tag color="red" style={{ fontWeight: "bold", fontSize: 13, padding: "2px 8px" }}>
                      {rec.totalQtyCount || rec.suggestedTransferQty} Units ({rec.totalPartsCount || 1} Parts)
                    </Tag>
                  </div>
                </div>
                <Button
                  type="danger"
                  style={{
                    backgroundColor: "#ff4d4f",
                    borderColor: "#ff4d4f",
                    color: "#fff",
                    fontWeight: 600,
                    borderRadius: 4,
                  }}
                  onClick={() => {
                    setAutoTransferData(rec);
                    setAddFlag(true);
                  }}
                  disabled={!createAccess}
                >
                  ⚡ Auto Transfer All ({rec.totalPartsCount || 1} Parts)
                </Button>
              </div>
            ))}
          </div>
        </div>
      )}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <Title level={4} style={{ margin: 0 }}>
          Spares Transfer [{count}]
          <span style={{ marginLeft: 12 }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button style={{ minWidth: 50 }}>
                {limit} <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <Search
            style={{ width: 220 }}
            placeholder="Search Spares"
            onSearch={handleSearch}
            allowClear
            size="default"
          />
          <Button
            style={{
              border: "1.5px solid #008080",
              color: "#008080",
              background: "#fff",
              borderRadius: 4,
              fontWeight: 500,
            }}
            onClick={() => setShowAdvanced((prev) => !prev)}
          >
            {showAdvanced ? "Back" : "Advanced Filters"}
          </Button>
          <Button
            type="primary"
            style={{ minWidth: 180 }}
            onClick={() => {
              setAutoTransferData(null);
              setAddFlag(true);
            }}
            disabled={!createAccess}
          >
            Add Spare Transfer
          </Button>
        </div>
      </div>
      {/* Advanced Filters Section */}
      {showAdvanced && (
        <div
          style={{
            background: "#f7fafd",
            border: "1px solid #e0e0e0",
            borderRadius: 8,
            padding: 24,
            margin: "18px 0 8px 0",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 32,
              flexWrap: "nowrap",
              alignItems: "center",
              width: "100%",
              minWidth: 700,
              overflowX: "auto",
            }}
          >
            <div
              style={{ display: "flex", alignItems: "center", minWidth: 260 }}
            >
              <label style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
                From Branch:
              </label>
              <Select
                style={{ marginLeft: 8, minWidth: 160 }}
                value={fromBranch}
                onChange={(val) => setFromBranch(val)}
                allowClear
                placeholder="Select Branch"
                showSearch
                optionFilterProp="children"
              >
                {branchOptions.map((branch) => (
                  <Option key={branch.id} value={branch.id}>
                    {branch.name}
                  </Option>
                ))}
              </Select>
            </div>
            <div
              style={{ display: "flex", alignItems: "center", minWidth: 220 }}
            >
              <label style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
                From Date:
              </label>
              <DatePicker
                style={{ marginLeft: 8, width: 140 }}
                value={fromDate}
                onChange={(date) => setFromDate(date)}
                format="YYYY-MM-DD"
                allowClear
                placeholder="Start date"
                disabledDate={(current) => {
                  // Disable dates after To Date if To Date is selected
                  if (toDate && current) {
                    return current && current > toDate.endOf('day');
                  }
                  return false;
                }}
              />
            </div>
            <div
              style={{ display: "flex", alignItems: "center", minWidth: 220 }}
            >
              <label style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
                To Date:
              </label>
              <DatePicker
                style={{ marginLeft: 8, width: 140 }}
                value={toDate}
                onChange={(date) => setToDate(date)}
                format="YYYY-MM-DD"
                allowClear
                placeholder="End date"
                disabledDate={(current) => {
                  // Disable dates before From Date if From Date is selected
                  if (fromDate && current) {
                    return current && current < fromDate.startOf('day');
                  }
                  return false;
                }}
              />
            </div>
            <Button
              type="primary"
              onClick={handleAdvancedSearch}
            >
              Search
            </Button>
            <Button onClick={handleAdvancedClear}>Clear</Button>
          </div>
        </div>
      )}
      <Table
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={spareTransfers}
        loading={loading}
        style={{ cursor: "pointer" }}
        pagination={false}
      />
      <div style={{ marginTop: 16, textAlign: "right" }}>
        <Pagination
          current={page}
          pageSize={limit}
          total={count}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
      <AddTransferSparesModal
        open={addFlag}
        close={() => {
          setAddFlag(false);
          setAutoTransferData(null);
        }}
        refreshData={() => {
          getSpareTransfers();
          getPendingTransfers();
        }}
        branchOptions={branchOptions}
        createAccess={createAccess}
        initialValues={autoTransferData}
      />
    </div>
  );
};

export default TransferSpares;
